import React from "react";
import styled from "styled-components";

export const IconArrow = styled.div`
	width: 1.375em;
	height: 0.875em;
	position: relative;
	display: inline-block;

	&:before,
	&:after {
		content: "";
		display: block;
		height: 0.1875em;
		width: 0.875em;
		background: #fff;
		position: absolute;
		top: 0;
	}

	&:before {
		left: 0;
		transform: rotateZ(45deg);
	}

	&:after {
		transform: rotateZ(-45deg);
		right: 0;
	}
`;

const Wrapper = styled.div`
	display: flex;
	flex-direction: column;
	align-items: center;
	position: sticky;
	bottom: 4vh;
	z-index: 3;
	pointer-events: none;

	@media (max-width: 768px) {
		display: none;
	}
`;

const Animate = styled.div`
	@keyframes bounceBottom {
		0% {
			opacity: 1;
			transform: translateY(0px) scale(1);
		}
		25% {
			opacity: 0;
			transform: translateY(10px) scale(0.9);
		}
		26% {
			opacity: 0;
			transform: translateY(-15px) scale(0.9);
		}
		55% {
			opacity: 1;
			transform: translateY(0px) scale(1);
		}
	}

	animation-name: bounceBottom;
	animation-duration: 1.5s;
	animation-iteration-count: infinite;
	animation-timing-function: linear;
`;

export const Scroll: React.FC = () => {
	return (
		<Wrapper>
			<Animate>
				<IconArrow />
			</Animate>
		</Wrapper>
	);
};
